import { render, staticRenderFns } from "./CalendarEventDates.vue?vue&type=template&id=43aa75a1"
import script from "./CalendarEventDates.vue?vue&type=script&lang=js"
export * from "./CalendarEventDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports